import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js';
import {initialErrors  } from '../../common/helper/form-constants.js';
import cashoutService from '../../../services/cashout-service.js';
import { FormField } from './../../common/helper/formFields';

const UploadBatchComponent = () => { 
  const [batch,setBatch] =useState({})
  const [fileUrl, setFileUrl] = useState('');

  const [loading, setLoading] = useState(false);
  const [formData,setFormData] = useState({});
  const userData = useSelector(state => state.authReducer);
  const [errors, setErrors] = useState({ ...initialErrors });
  const navigate = useNavigate();
  const { id } = useParams();
  const [batchResponse,setBatchResponse] = useState();

  const [role,setUserRole] = useState();
  const dispatch = useDispatch();


  const getBatchDetails = () => {
    setLoading(true);
    cashoutService.batchDetails(id)
      .then(response => {
        setBatch(response.data.data)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  const handleFileChange  = (e) => {
    const file = e.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    

    if (file && file.size <= maxSize) {
      setFileUrl(file);
    } else {
      setFileUrl('');
      toast.error('File size exceeds 2 MB. Please select a smaller file.');
    }

  }

  const submitBatch = () => {
    if(!fileUrl) {
      toast.error('Please upload batch file.');
      return
    }
    setLoading(true);
    const data = new FormData();
    data.append('file',fileUrl);
  
    cashoutService.uploadBatch(id,data)
      .then(response => {
        setBatchResponse(response.data.data)
        setFileUrl('');
        const fileInput = document.getElementById('imageInput');
        if (fileInput) {
          fileInput.value = '';
        }
        toast.success(MESSAGES.FILE_UPLOADED)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });
  }
  const downloadBatchFile = () => {
    const decodedData = atob(batchResponse.file); 
    const blob = new Blob([decodedData], { type: 'text/csv' });

    // Create a URL and trigger download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'batch.csv'; // Set the desired file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success(MESSAGES.FILE_DOWNLOADED)

  }
    useEffect(() => {
      getBatchDetails()
      setUserRole(userData.user.data.role.role_code.toLowerCase())
      
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);

const back = () => {
    navigate('/cashout'); 
  }
return (
<>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
      <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Upload Batch Response</h4>
      <div className="container-fluid ghty" style={{backgroundColor: 'white', float: 'left'}}>
        <div className="container col-md-12" style={{padding: 0}}>
            <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                <FormField
                           type="text"
                           isRequierd = {false}
                           id="f_name"
                           name="fullName"
                           label="Batch ID"
                           placeholder = "Batch ID"
                           value={batch.batch_id}
                          
                           error={errors.fullName}
                           maxlength = {100}
                           disabled={true}
                        />
                    </div>
                </div>
                <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                <FormField
                           type="text"
                           isRequierd = {false}
                           id="f_name"
                           name="fullName"
                           label="Pending Count"
                           placeholder = "Pending Count"
                           value={batch.pending_count}
                        
                           error={errors.fullName}
                           maxlength = {100}
                           disabled={true}
                        />
                    </div>
                </div>
            </div>

    <div style={{width:'100%', float:'left'}}>
      <form method="post" id="register_form" action="#" className="merchant_form">
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className={`nav-link active_tab1`}  id="list_per_details">Upload via File</a>
          </li>
          
        </ul>
        <div className="tab-content" style={{marginTop: '16px'}}>
          <div className={`tab-pane active`} id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                  
                        <label className='required'> Upload Batch File</label>
                        <br></br>
                        <input style={{width: '250px', display: 'inline'}} onChange={handleFileChange} type="file" className="form-control" id="imageInput"   name="f_name" />
                        
                     
                    </div>
                 
                 
                   
                  </div>
          
                </div>
               
                <div align="left">
                  <button type="button" style={{'marginTop':'9px'}} name="btn_login_details" id="btn_login_details" className="btn ddfg" onClick={submitBatch}>Submit</button>
                  <button type="button" style={{'marginTop':'15px',marginLeft:'10px'}} name="btn_login_details" id="btn_login_details" className="btn backbt" onClick={back}>Back</button>
                  
                </div>
                <br />
              </div>
            </div>
          </div>
    
        </div>
        </form>
        </div>

        {batchResponse && (
          <>
           <div className="card-batch" style={{float:'left',width:'100%',marginBottom:'30px'}}>
           <table className="table-batch">
           <thead>
             <tr>
              <th>Total Count</th>
               <th>Pass Count</th>
               <th>Fail Count</th>
               <th>No Change Count</th>
               <th>File</th>
             </tr>
           </thead>
           <tbody>
             <tr>
             <td>{batchResponse.total_count}</td>
               <td>{batchResponse.pass_count}</td>
               <td>{batchResponse.fail_count}</td>
               <td>{batchResponse.nochange_count}</td>
               <td>
                 <a href="#" onClick={downloadBatchFile}>Download</a>
               </td>
             </tr>
            
           </tbody>
           </table>
       </div>
       <br /> <br />
       </>
        )}
        
      </div>

     
      
    </div>
    </>
  );

}


 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(UploadBatchComponent));